import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function AdminPanel() {
  const [events, setEvents] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [usage, setUsage] = useState(null);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetchEvents();
    fetchTemplates();
    fetchUsage();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await fetch(API + '/analytics/events?days=30', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setEvents(await res.json());
    } catch (err) { console.error(err); }
  };

  const fetchTemplates = async () => {
    try {
      const res = await fetch(API + '/templates', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setTemplates(d.templates || []); }
    } catch (err) { console.error(err); }
  };

  const fetchUsage = async () => {
    try {
      const res = await fetch(API + '/ai/usage', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setUsage(await res.json());
    } catch (err) { console.error(err); }
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🔧 Админ-панель</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Внутренняя панель для владельца. Видна только вам.
      </p>

      {/* Метрики за 30 дней */}
      <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📊 События (30 дней)</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 20 }}>
        <div style={statCard}>
          <div style={statLabel}>Всего событий</div>
          <div style={statValue}>{events?.total_events || 0}</div>
        </div>
        <div style={statCard}>
          <div style={statLabel}>Уникальных пользователей</div>
          <div style={{...statValue, color: '#10B981'}}>{events?.unique_users || 0}</div>
        </div>
        <div style={statCard}>
          <div style={statLabel}>ИИ-запросов (месяц)</div>
          <div style={{...statValue, color: '#F7DE8A'}}>{usage?.requests_count || 0}/{usage?.limit_count || 20}</div>
        </div>
        <div style={statCard}>
          <div style={statLabel}>Тариф</div>
          <div style={{...statValue, color: '#6366F1'}}>{usage?.plan || 'free'}</div>
        </div>
      </div>

      {/* Топ функций */}
      {events?.by_feature && Object.keys(events.by_feature).length > 0 && (
        <>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>🔥 Топ функций</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
            {Object.entries(events.by_feature).sort((a, b) => b[1] - a[1]).map(([feature, count]) => (
              <div key={feature} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#F8FAFC' }}>{feature}</span>
                <span style={{ color: '#F7DE8A', fontWeight: 700 }}>{count}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Шаблоны пользователей */}
      <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 Пользовательские шаблоны ({templates.length})</h3>
      {templates.length === 0 && <p style={{ color: '#94A3B8', fontSize: 13 }}>Пока нет пользовательских шаблонов</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {templates.map(t => (
          <div key={t.id} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636' }}>
            <div style={{ color: '#F7DE8A', fontWeight: 600 }}>{t.name}</div>
            <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>Ниша: {t.niche} • Тип: {t.contract_type}</div>
          </div>
        ))}
      </div>

      {/* Быстрые действия */}
      <h3 style={{ color: '#F7DE8A', marginBottom: 12, marginTop: 20 }}>⚡ Быстрые действия</h3>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button onClick={fetchEvents} style={btnStyle}>🔄 Обновить события</button>
        <a href={API + '/health'} target="_blank" rel="noopener noreferrer" style={{ ...btnStyle, textDecoration: 'none', display: 'inline-block' }}>❤️ Проверить API</a>
        <a href="https://khepri.tech/metrics" target="_blank" rel="noopener noreferrer" style={{ ...btnStyle, textDecoration: 'none', display: 'inline-block' }}>📈 Prometheus</a>
      </div>

      <div style={{ marginTop: 20, padding: 14, background: 'rgba(245,158,11,0.15)', border: '1px solid #F59E0B', borderRadius: 8, fontSize: 13, color: '#94A3B8' }}>
        ⚠️ В будущем эта панель будет видна только по роли «owner». Сейчас доступна всем — для теста.
      </div>
    </div>
  );
}

const statCard = { background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' };
const statLabel = { fontSize: 11, color: '#94A3B8', marginBottom: 6 };
const statValue = { fontSize: 22, fontWeight: 700, color: '#F8FAFC' };
const btnStyle = { padding: '10px 20px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13 };

export default AdminPanel;